import { IconExternalLink } from '@tabler/icons-react';
import React from 'react';
import {
  BasicActionIcon,
  IBasicActionIconProps,
} from 'src/design/atoms/BasicActionIcon';

export type IExternalLinkActionIconProps = Omit<
  IBasicActionIconProps,
  'children' | 'onClick' | 'type'
> & {
  href: string;
  target?: React.HTMLAttributeAnchorTarget;
  rel?: string;
};

const DefaultProps: Partial<IExternalLinkActionIconProps> = {
  color: 'blue',
};

/** @registry Blue external-link action icon (opens an anchor) built on BasicActionIcon; renders as an <a> so it is an accessible link. Pass an aria-label for its accessible name. */
export const ExternalLinkActionIcon = React.forwardRef<
  HTMLAnchorElement,
  IExternalLinkActionIconProps
>((props, ref) => {
  return (
    <BasicActionIcon component="a" {...DefaultProps} {...props} ref={ref}>
      <IconExternalLink size={20} />
    </BasicActionIcon>
  );
});
ExternalLinkActionIcon.displayName = 'ExternalLinkActionIcon';
